import { getTimeZones } from '@vvo/tzdb';
import moment from 'moment';

interface TimezoneObject {
  name: string;
  display: string;
}
/**
 * Formats the timezone data from the tzdb package to be used in the timezone selector on client creation
 * @returns array of timezone objects
 */
export const formatTimezones = () => {
  const formattedTimeZones: TimezoneObject[] = getTimeZones().map((timezone) => {
    const timezoneObj: TimezoneObject = {
      name: timezone.name,
      display: generateTimezoneDisplay(timezone.name, timezone.currentTimeOffsetInMinutes) //Use current time zone offset, which accounts for DST
    };
    return timezoneObj;
  });

  return formattedTimeZones;
};

/**
 * Generates the display string for given timezone - e.g. "Africa/Johannesburg (GMT +02:00)"
 * @param timezone - timezone name
 * @param offset - timezone offset in minutes
 * @returns timezone display string
 */
export const generateTimezoneDisplay = (timezone: string, offset?: number) => {
  if (!timezone) return 'No timezone set';

  if (offset === undefined) {
    const tz = getTimeZones().find((tz) => tz.name === timezone);
    if (tz) {
      offset = tz.currentTimeOffsetInMinutes;
    }
  }

  if (offset === undefined) return timezone;

  const hours = moment.utc().startOf('day').add(Math.abs(offset), 'minutes').format('HH:mm');
  const sign = offset >= 0 ? '+' : '-';

  return `${timezone} (GMT ${sign}${hours})`;
};
